export const FIXED_GUARANTEED = 'fixed_guaranteed';
export const GUARANTEED_PLUS = 'guaranteed_plus';
export const ALL_GUARANTEED = [FIXED_GUARANTEED, GUARANTEED_PLUS];
export const FLEXIBLE_GUARANTEED = 'flexible_guaranteed';
export const MULTIPLIER = 'multiplier';
